import TopContentBanner from './TopContentBanner'

export default TopContentBanner
